"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OBFUSCATED_FORMATS = exports.DEFAULT_TLRU_TTL_MS = exports.BANDIT_ASSIGNMENT_SHARDS = exports.MAX_EVENT_QUEUE_SIZE = exports.NULL_SENTINEL = exports.SESSION_ASSIGNMENT_CONFIG_LOADED = exports.PRECOMPUTED_FLAGS_ENDPOINT = exports.PRECOMPUTED_BASE_URL = exports.BANDIT_ENDPOINT = exports.UFC_ENDPOINT = exports.BASE_URL = exports.DEFAULT_POLL_CONFIG_REQUEST_RETRIES = exports.DEFAULT_INITIAL_CONFIG_REQUEST_RETRIES = exports.POLL_JITTER_PCT = exports.DEFAULT_POLL_INTERVAL_MS = exports.REQUEST_TIMEOUT_MILLIS = exports.DEFAULT_REQUEST_TIMEOUT_MS = void 0;
const interfaces_1 = require("./interfaces");
exports.DEFAULT_REQUEST_TIMEOUT_MS = 5000;
exports.REQUEST_TIMEOUT_MILLIS = exports.DEFAULT_REQUEST_TIMEOUT_MS; // for backwards compatibility
exports.DEFAULT_POLL_INTERVAL_MS = 30000;
exports.POLL_JITTER_PCT = 0.1;
exports.DEFAULT_INITIAL_CONFIG_REQUEST_RETRIES = 1;
exports.DEFAULT_POLL_CONFIG_REQUEST_RETRIES = 7;
exports.BASE_URL = 'https://fscdn.eppo.cloud/api';
exports.UFC_ENDPOINT = '/flag-config/v1/config';
exports.BANDIT_ENDPOINT = '/flag-config/v1/bandits';
exports.PRECOMPUTED_BASE_URL = 'https://fs-edge-assignment.eppo.cloud';
exports.PRECOMPUTED_FLAGS_ENDPOINT = '/assignments';
exports.SESSION_ASSIGNMENT_CONFIG_LOADED = 'eppo-session-assignment-config-loaded';
exports.NULL_SENTINEL = 'EPPO_NULL';
// number of logging events that may be queued while waiting for initialization
exports.MAX_EVENT_QUEUE_SIZE = 100;
exports.BANDIT_ASSIGNMENT_SHARDS = 10000;
exports.DEFAULT_TLRU_TTL_MS = 600000;
/**
 * UFC Configuration formats which are obfuscated.
 *
 * We use string[] instead of FormatEnum[] to allow easy interaction with this value in its wire type (string).
 * Converting from string to enum requires a map lookup or array iteration and is much more awkward than the inverse.
 */
exports.OBFUSCATED_FORMATS = [interfaces_1.FormatEnum.CLIENT, interfaces_1.FormatEnum.PRECOMPUTED];
//# sourceMappingURL=constants.js.map